import { Grid, Typography } from '@mui/material';
import { useContact } from '../../../sic-lib/api/hooks/useContact';
import { useAppSelector } from '../../../store/hooks';
import UserChip from '../../Settings/Users/UserChip';
import Loader from '../../Shared/Loader';

interface Props {
    contactId: number | undefined;
}

export function IncomingCallContactInfo({ contactId }: Props) {
    const { data, isLoading } = useContact(contactId);
    const users = useAppSelector(state => state.user.users);
    const contactOwner = data?.owners.find(o => o.isPrimary)?.userName;

    return (
        <Loader isLoading={isLoading}>
            {data && (
                <Grid item container flexDirection="column" justifyContent="center" spacing={1}>
                    <Grid item container justifyContent="center">
                        <Typography variant="caption">Contact Owner</Typography>
                    </Grid>
                    <Grid item container justifyContent="center">
                        <UserChip users={users} userName={contactOwner} />
                    </Grid>
                </Grid>
            )}
        </Loader>
    );
}
